<template>
  <div>
    <Head title="Wijk aanmaken" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-accent-primary-text" href="/municipalities">Wijken</Link>
      <span class="text-accent-primary-text font-medium">/</span> Aanmaken
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.zip" :error="form.errors.zip" class="pb-8 pr-6 w-full lg:w-1/2" label="Postcode" />
          <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2" label="Naam" />          
          <!-- <text-input v-model="form.open_street_map_relation_id" :error="form.errors.open_street_map_relation_id" class="pb-8 pr-6 w-full lg:w-1/2" label="Open street map relation id" /> -->

          <!-- <text-input v-model="form.city" :error="form.errors.city" class="pb-8 pr-6 w-full lg:w-1/2" label="City" />
          <text-input v-model="form.region" :error="form.errors.region" class="pb-8 pr-6 w-full lg:w-1/2" label="Province/State" />
          <select-input v-model="form.country" :error="form.errors.country" class="pb-8 pr-6 w-full lg:w-1/2" label="Country">
            <option :value="null" />
            <option value="CA">Canada</option>
            <option value="US">United States</option>
          </select-input>
          <text-input v-model="form.postal_code" :error="form.errors.postal_code" class="pb-8 pr-6 w-full lg:w-1/2" label="Postal code" /> -->
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">Wijk aanmaken</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
  },
  layout: Layout,
  props: {    
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        zip: '',
        name: '',
        // open_street_map_relation_id: null        
      }),
    }
  },
  methods: {
    store() {
      this.form.post('/municipalities')
    },
  },
}
</script>
